import {
  AccountInfo,
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication
} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import { SWRConfig } from "swr";

import { Sidebar } from "@digital-services/ui";

import { msalConfig } from "./authConfig";
import { router } from "./routes";

import "./i18n";
import "./main.css";

const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();
let account: AccountInfo | null = null;
if (accounts.length > 0) {
  account = accounts[0];
  msalInstance.setActiveAccount(account);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});
const swrConfig = { shouldRetryOnError: false };

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sidebar.Provider>
      <React.Suspense
      // TBD, try again
      // It is loading, but NOT centered, but to the top, in the middle, because requires PageContext
      // fallback={<LoadingPage message="React.Suspense loading" />}
      // Not centered, but in left-top corner
      // fallback={<LoadingIndicator />}
      >
        <MsalProvider instance={msalInstance}>
          <SWRConfig value={swrConfig}>
            <RouterProvider router={router} />
          </SWRConfig>
        </MsalProvider>
      </React.Suspense>
    </Sidebar.Provider>
  </React.StrictMode>
);
